module.exports = __webpack_public_path__ + "8043e42bee3f802af99f3a738adfe6ad.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/logo/logo.svg
// module id = 161
// module chunks = 0